import { combineReducers } from "redux";
import { commonReducer as common } from "./common";
const rootReducer = combineReducers({
    common
});

export default rootReducer;